<template>
  <a-modal v-model:visible="visible" title="订单发货" @ok="handleOk" ok-text="确定" cancel-text="取消" :confirm-loading="confirmLoading" destroyOnClose>
    <a-form ref="formRef" :model="formState" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <!-- <a-form-item label="订单号">
        <span style="font-weight: bold;">{{ orderNo || '--' }}</span>
      </a-form-item> -->

      <a-form-item label="快递公司" name="expressCompanyName" :rules="[{ required: true, message: '请选择快递公司' }]">
        <a-select v-model:value="formState.expressCompanyName" placeholder="请选择">
          <a-select-option value="顺丰">顺丰</a-select-option>
          <a-select-option value="申通">申通</a-select-option>
          <a-select-option value="中通">中通</a-select-option>
          <a-select-option value="极兔">极兔</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="快递单号" name="trackingNumber" :rules="[{ required: true, message: '请输入快递单号' }]">
        <a-input v-model:value="formState.trackingNumber" placeholder="请输入单号" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { ExecuteOperation } from '@/api/order';

export default {
  name: 'ShipModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    uuid: {
      type: String,
      default: ''
    },
    orderNo: {
      type: String,
      default: ''
    },
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      confirmLoading: false,
      formState: {
        expressCompanyName: undefined,
        trackingNumber: '',
        operation: '发货'
      }
    };
  },
  methods: {
    async handleOk() {
      console.log(this.detail);
      try {
        await this.$refs.formRef.validate();
        this.confirmLoading = true;

        // 构造符合接口要求的 payload
        const payload = {
          uuid: this.detail.uuid,
          expressCompanyName: this.formState.expressCompanyName,
          trackingNumber: this.formState.trackingNumber,
          operation: this.formState.operation
        };

        const res = await ExecuteOperation(payload);
        if (res.errCode === 0) {
          this.$message.success('发货成功');
          this.$emit('refresh'); // 通知父组件刷新列表
          this.handleCancel();
        } else {
          this.$message.error(res.message || '操作失败');
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.confirmLoading = false;
      }
    },
    handleCancel() {
      this.$emit('update:visible', false);
      this.formState = { expressCompanyName: undefined, trackingNumber: '', operation: '发货' };
    }
  }
};
</script>

<style scoped>
</style>